import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/travis/build/morewings/react-calendar-toolkit/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Datepicker } from 'lib';
import { Playground } from 'docz';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`You can apply a custom theme to `}<inlineCode parentName="p">{`Datepicker`}</inlineCode>{` and `}<inlineCode parentName="p">{`DatepickerInput`}</inlineCode>{` components.`}</p>
    <p>{`It supports basic theming (colors, width, paddings and fonts). You can provide custom theme object, overriding default theme properties.`}</p>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <Playground __position={0} __code={'() => {\n  /**\n   * Default theme overrides\n   * @typedef {Object.<string, string>} theme\n   */\n  const theme = {\n    \'--bgColor\': \'#fffff0\',\n    \'--headerBgColor\': \'purple\',\n    \'--entrySelectedColor\': \'purple\',\n  }\n  return (\n    <Datepicker\n      theme={theme}\n      onDateSet={date => {\n        console.log(\'date set\', date)\n      }}\n      title=\"Demo datepicker\"\n    />\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Datepicker,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        /**
         * Default theme overrides
         * @typedef {Object.<string, string>} theme
         */
        const theme = {
          '--bgColor': '#fffff0',
          '--headerBgColor': 'purple',
          '--entrySelectedColor': 'purple'
        };
        return <Datepicker theme={theme} onDateSet={date => {
          console.log('date set', date);
        }} title="Demo datepicker" mdxType="Datepicker" />;
      }}
    </Playground>
    <h2 {...{
      "id": "default-theme"
    }}>{`Default theme`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// src/utils/defaultTheme.js

const defaultTheme = {
  /** Set font for datepicker */
  'fontPrimary': 'Helvetica Neue',
  /** Font, which is applied, if --fontPrimary is not available */
  'fontSecondary': 'Arial',
  /** Fallback font if two previous are unavailable */
  'fontFallback': 'sans-serif',
  'fontSize': '14px',
  'fontWeight': '400',
  /** Applied to the title */
  'fontSizeSmall': '10px',
  /** Applied to the header text */
  'fontSizeBig': '24px',
  /** Set inner width */
  'calendarWidth': '240px',
  /** Calculate total width */
  'datePickerWidth': 'calc(var(--calendarWidth) + var(--innerPadding) * 2)',
  'selectorHeight': '36px',
  'calendarHeight': '200px',
  /** Set padding between elements */
  'innerPadding': '12px',
  /** Day, month, year entries height */
  'entryHeight': '32px',
  'entryMargin': '1px',
  'datepickerBorderRadius': borderRadius,
  'entryBorderRadius': borderRadius,
  /** Background color of Calendar */
  'bgColor': 'white',
  /** Base color for text */
  'textColor': 'black',
  'headerBgColor': baseColor,
  'weekendTextColor': 'red',
  'headerTextColor': 'white',
  'borderColor': gray,
  'modalBgColor': gray,
  'weekDayColor': gray,
  'entryHoverColor': 'rgba(0, 0, 0, 0.08)',
  'entrySelectedColor': baseColor,
  'entryHighlightColor': 'lightblue',
  'inputWidth': '90px',
  'inputPadding': '8px',
  'inputBorderRadius': borderRadius,
  'inputBorderColor': gray,
  'inputHighlightColor': 'lightblue',
};
`}</code></pre>
    <p>{`Each theme entry is applied as `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/--*"
      }}>{`CSS Custom Property`}</a>{` to the Datepicker wrapping DOM node.`}</p>
    <p>{`Default theme is defined here - `}<inlineCode parentName="p">{`src/utils/defaultTheme.js`}</inlineCode></p>
    <h2 {...{
      "id": "css-variables-handling"
    }}>{`CSS variables handling`}</h2>
    <p>{`You can change each theme property dynamically. `}<inlineCode parentName="p">{`RCT`}</inlineCode>{` exposes 3 helpers functions to handle CSS variables inside your components - `}<inlineCode parentName="p">{`setCSSVariable`}</inlineCode>{`, `}<inlineCode parentName="p">{`getCSSVariable`}</inlineCode>{` and `}<inlineCode parentName="p">{`removeCSSVariable`}</inlineCode>{`. Values are set or changed inside provided HTML Element context.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "static",
        "static": true
      }}>{`import React, {useRef} from 'react';
import {setCSSVariable, getCSSVariable, removeCSSVariable} from 'react-calendar-toolkit';

const Component = () => {
    const targetElement = useRef();
    /** @function
     * @name setCSSVariable
     * @description Set CSS variable
     * @param {HTMLElement} element - HTML element to contain variable
     * @param {string} variableName - variable name, should start with \`--\`
     * @param {string} value
     * @return {void}
     */
    setCSSVariable(targetElement.current, '--varName', 'value');

    /** @function
     * @name getCSSVariable
     * @description Get CSS variable value
     * @param {HTMLElement} element - HTML element to contain variable
     * @param {string} variableName - variable name, should start with \`--\`
     * @return {string}
     */
    getCSSVariable(targetElement.current, '--varName'); // 'value'

    /** @function
     * @name removeCSSVariable
     * @description Remove CSS variable
     * @param {HTMLElement} element - HTML element to contain variable
     * @param {string} variableName - variable name, should start with \`--\`
     * @return {void}
     */
    removeCSSVariable(targetElement.current, '--varName');
    return (
      <div ref={targetElement}>
        {/*...*/}
      </div>
    )
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      